import styled from 'styled-components';

import { ds } from '@/config/colors';

export const UpdatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const UpdateRow = styled.div<{ $error?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.45;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#cbd5e1' : ds.textSecondary)};
  background: ${({ theme, $error }) => {
    if ($error) return theme.mode === 'dark' ? 'rgba(220, 38, 38, 0.12)' : '#fef2f2';
    return theme.mode === 'dark' ? 'rgba(16, 185, 129, 0.10)' : '#f0fdf4';
  }};

  svg {
    width: 14px;
    height: 14px;
    margin-top: 2px;
    flex-shrink: 0;
    color: ${({ $error }) => ($error ? '#dc2626' : '#10b981')};
  }
`;

export const UpdateText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const UpdateTime = styled.span`
  display: block;
  font-size: 11px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#94a3b8' : ds.textMuted)};
`;

/** Przejście do pełnej listy logów agenta; tekstowy link, nie przycisk. */
export const AllLogsLink = styled.a`
  align-self: flex-start;
  font-size: 12px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#cbd5e1' : ds.textSecondary)};
  text-decoration: underline;
  text-underline-offset: 3px;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
